var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 15,
    viewBox: "0 0 21 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50562 4.51188C2.50562 2.46948 4.08882 0.813477 6.04222 0.813477C7.99573 0.813477 9.57982 2.46958 9.57982 4.51188C9.57982 6.55408 7.99583 8.20924 6.04222 8.20924C4.08872 8.20924 2.50562 6.55418 2.50562 4.51188ZM7.92982 4.51188C7.92982 3.42227 7.08446 2.53848 6.04223 2.53848C5.00027 2.53848 4.15562 3.42197 4.15562 4.51188C4.15562 5.60149 4.99999 6.48424 6.04223 6.48424C7.08474 6.48424 7.92982 5.60119 7.92982 4.51188Z",
    fill: "#00A862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04206 6.81348C9.28835 6.81348 11.9355 9.49787 12.0627 12.8585L12.0675 13.1118V14.1736H10.4175V13.1118C10.4175 10.5865 8.45828 8.53848 6.04206 8.53848C3.69989 8.53848 1.78673 10.4644 1.67293 12.8836L1.66758 13.1118V14.1736H0.0175781V13.1118C0.0175781 9.63395 2.71542 6.81348 6.04206 6.81348Z",
    fill: "#00A862"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6411 4.51188C10.6411 2.46927 12.2245 0.813477 14.1787 0.813477C16.1314 0.813477 17.7153 2.46978 17.7153 4.51188C17.7153 6.55387 16.1315 8.20924 14.1787 8.20924C12.2244 8.20924 10.6411 6.55439 10.6411 4.51188ZM16.0653 4.51188C16.0653 3.42238 15.2201 2.53848 14.1787 2.53848C13.1359 2.53848 12.2911 3.42186 12.2911 4.51188C12.2911 5.6016 13.1356 6.48424 14.1787 6.48424C15.2203 6.48424 16.0653 5.60108 16.0653 4.51188Z",
    fill: "#00A862"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1781 6.81348C17.4245 6.81348 20.0707 9.4979 20.1978 12.8595L20.2026 13.1128V14.1736H18.5526V13.1128C18.5526 10.5864 16.5942 8.53848 14.1781 8.53848C12.9116 8.53848 11.7364 9.10311 10.9142 10.0667L10.7546 10.2646L9.46387 9.19005C10.5992 7.69957 12.3193 6.81348 14.1781 6.81348Z",
    fill: "#00A862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.d9b3208ec333306e126024c0c6a1fa8a.svg";
export { ForwardRef as ReactComponent };